import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table report view for hash data.
 */
export default class tableReportHashView extends JetView {
    /**
     * Configures the datatable layout and properties.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Current user parameter
        const id_partner = this.getParam('partner', true); // Partner ID parameter

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions for the datatable
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Descargar'), // Tooltip for download action
                    template: function (obj) {
                        // Template for download icon
                        return "<span class='webix_icon wxi-close download'></span>";
                    },
                },
                { id: 'Id', header: _('ID'), width: 100, sort: 'int' }, // ID column
                {
                    id: 'FileName',
                    header: _('Nombre Archivo'), // File name column
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'Platform',
                    header: _('Plataforma'), // Platform column
                    editor: 'combo', // Combo editor for this column
                    options: [{ id: '0', value: _('Backend') }], // Options for the combo editor
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'OriginalHash',
                    header: _('Hash Original'), // Original hash column
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'DetectedHash',
                    header: _('Hash Detectado'), // Detected hash column
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'ModificationDate',
                    header: _('Fecha modificación'), // Modification date column
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'LastDetectionDate',
                    header: _('Fecha ultima detección'), // Last detection date column
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date formatting
                },
            ],
            onClick: {
                // Event handler for click events
                download: function (euv, id) {
                    // Download action
                    var item = this.getItem(id); // Get the clicked item
                    window.open(item.PdfUrl); // Open the PDF URL
                },
            },
            ready: function () {
                // Event handler for when the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // No data message
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Partner ID parameter
        var url = devConfig.geturlApi() + 'es/ReportHash/GetReportHash?Partner=' + id_partner + '&'; // Base URL for API requests
        var filter = ''; // Filter string for API requests
        const cur_user = this.getParam('user', true); // Current user parameter

        this.on(this.app, 'reportHash:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string to be built
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Handle created date filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            // Handle modified date filter
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to filter
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to filter
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format dateFrom
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format dateTo
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                // Load sorted data
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir,
            );
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item clicks
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                // Load data based on selected player
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
